import { gql } from "@apollo/client";

export const classroomBookings = gql`
  query classroomBookings($scenarioId: ID!, $originId: ID!, $filter: ClassroomBookingFilterInput) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookings(filter: $filter) {
        pendingCount
        activeCount
        expiredCount
        items {
          id
          title
          status
          capacity
          createdAt
          isActive
          sessions {
            id
            scheduleEvent {
              id
              start
              end
            }
          }
          responsible {
            id
            name
            lastName
          }
          classroom {
            id
            code
            name
            capacity
            building {
              id
              code
              name
              campus {
                code
              }
            }
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
          __typename
        }
      }
    }
  }
`;

export const classroomBookingsCount = gql`
  query classroomBookingsCount(
    $scenarioId: ID!
    $originId: ID!
    $filter: ClassroomBookingFilterInput
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookings(filter: $filter) {
        pendingCount
        activeCount
        expiredCount
      }
    }
  }
`;

export const classroomBookingsWithoutCount = gql`
  query classroomBookings($scenarioId: ID!, $originId: ID!, $filter: ClassroomBookingFilterInput) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookings(filter: $filter) {
        items {
          id
          title
          status
          capacity
          createdAt
          isActive
          sessions {
            scheduleEvent {
              id
              start
              end
              __typename
            }
            events {
              interval {
                id
                startingDate
                endingDate
                name
                __typename
              }
              block {
                day
                __typename
              }
              __typename
            }
            classrooms {
              id
              code
              name
              capacity
              isSpecialTagValue
              building {
                id
                code
                name
                campus {
                  id
                  code
                  name
                  __typename
                }
                __typename
              }
              classroomType {
                id
                code
                name
                __typename
              }
              __typename
            }
            __typename
          }
          classroom {
            id
            code
            name
            capacity
            isSpecialTagValue
            building {
              id
              code
              name
              campus {
                id
                code
                name
                __typename
              }
              __typename
            }
            classroomType {
              id
              code
              name
              __typename
            }
            __typename
          }
          responsible {
            id
            name
            lastName
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
          __typename
        }
      }
    }
  }
`;
